import { apiClient } from 'api/client/apiClient';
import { ApplicationDTO } from '../types';
import { API_URLS } from '../consts';

export const fetchApplications = async () => {
  const result = await apiClient.get<ApplicationDTO[]>(`${API_URLS.Applications}/applications`);

  return result.data;
};
